<template>
  <div>
    <HeadingHuge>Typography</HeadingHuge>
    <HeadingHuge>Heading Huge</HeadingHuge>
    <ParagraphBody>
      {{ sampleText }}
    </ParagraphBody>

    <HeadingLarge>Heading Large</HeadingLarge>
    <ParagraphBody>
      {{ sampleText }}
    </ParagraphBody>

    <HeadingMedium>Heading Medium</HeadingMedium>
    <ParagraphBody>
      {{ sampleText }}
    </ParagraphBody>
    <ParagraphBody>
      {{ sampleText }}
    </ParagraphBody>

    <HeadingSmall>Heading Small</HeadingSmall>
    <ParagraphBody>
      {{ sampleText }}
    </ParagraphBody>

    <HeadingExtraSmall>Heading Extra Small</HeadingExtraSmall>
    <ParagraphBody>
      {{ sampleText }}
    </ParagraphBody>

    <HeadingMedium :hasMargin="false">
      Heading Medium (No Margin)
    </HeadingMedium>
    <ParagraphBody :hasMargin="false">
      {{ sampleText }}
      Hold the margin...
    </ParagraphBody>
    <ParagraphBody :hasMargin="false">
      {{ sampleText }}
      Hold the margin...
    </ParagraphBody>

    <HeadingSmall>Paragraph Large</HeadingSmall>
    <ParagraphBody bodySize="large">
      {{ sampleText }}
    </ParagraphBody>

    <HeadingSmall>Paragraph Normal</HeadingSmall>
    <ParagraphBody>
      {{ sampleText }}
    </ParagraphBody>

    <HeadingSmall>Paragraph Small</HeadingSmall>
    <ParagraphBody bodySize="small">
      {{ sampleText }}
    </ParagraphBody>

    <HeadingExtraSmall>Paragraph Tiny</HeadingExtraSmall>
    <ParagraphBody bodySize="tiny">
      {{ sampleText }}
    </ParagraphBody>

    <HeadingLarge>Font Weights</HeadingLarge>
    <ParagraphBody
      v-for="weight in fontWeights"
      :key="weight"
      :weight="weight"
    >
      {{ weight }}: {{ sampleText }}
    </ParagraphBody>
  </div>
</template>

<script>
import {
  HeadingExtraSmall,
  HeadingHuge,
  HeadingLarge,
  HeadingMedium,
  HeadingSmall,
  ParagraphBody,
} from '@jumpcloud/ui-components';

export default {
  name: 'StickerTypography',

  components: {
    HeadingExtraSmall,
    HeadingHuge,
    HeadingLarge,
    HeadingMedium,
    HeadingSmall,
    ParagraphBody,
  },

  data() {
    return {
      fontWeights: ['light', 'normal', 'semibold', 'bold', 'black'],
      sampleText: `This is the sample text for this text size.  It should give you an idea of
        what a text blurb in this sizing is going to look like.  It looks pretty great, right?
        Think you want this size?`,
    };
  },
};
</script>

<style>

</style>
